module.exports = __webpack_public_path__ + "media/images/logos/google_calendar-f9e544e455537446a172752eeafd9c06.svg";